import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { IonicModule } from '@ionic/angular';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SimpleButtonComponent, TitleContentComponent } from 'ngx-zcs-components';

import { BlockTitleComponent } from '../../components/block-title/block-title.component';
import { SystemPortingComponent } from './system-porting.component';

@NgModule({
  declarations: [
    SystemPortingComponent,
  ],
  imports: [
    BlockTitleComponent,
    TitleContentComponent,
    CommonModule,
    IonicModule,
    MatIconModule,
    SimpleButtonComponent,
  ],
  exports: [
    SystemPortingComponent,
  ],
})
export class SystemPortingModule { }
